/* istanbul ignore file */
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PERKSGROUP } from 'src/app/core/constants/feature-key.constants';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { PreInitSettingsService } from '../../../../core/services/settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GetStartedModalComponent } from 'src/app/shared/components/get-started-modal/get-started-modal.component';

@Component({
  selector: 'pgh-call-to-action-section',
  templateUrl: './call-to-action-section.component.html',
  styleUrls: ['./call-to-action-section.component.scss']
})
export class CallToActionSectionComponent implements OnInit {

  isPrimary: boolean = false;
  isPerksModuleEnabled: boolean = false;
  perks: Array<string>;
  isPerkLoaded: boolean = false;
  isSinglePerk: boolean = false;
  isActive: boolean = false;
  singlePerk: string;
  perkButtonAria: string;
  singlePerkSvgIcon: string;
  singlePerkButtonOpenInNewWIndow: boolean = false;
  singlePerkButtonRoute: string;
  isPartnerLabelActive: boolean = false;
  isMobile: boolean = false;
  isTutorial: boolean = false;

  constructor(private loggedInUserSettings: LoggedInUserSettings,
    private resourceService: ADPResourceService,
    private preInitSettingsService: PreInitSettingsService,
    private breakpointObserver: BreakpointObserver,    
    private matDialog: MatDialog) {
  }

  ngOnInit() {
    const joined$ = combineLatest(
      [
        this.loggedInUserSettings.$selectedContract,
      ]
    ).pipe(
      filter(([a]) => a !== null )
    );


    joined$.subscribe(([selectedContract]: [ISelectedContract]) => {
      this.isPrimary = selectedContract && selectedContract.isPrimary && !selectedContract.isPTPO;
      this.isActive = (!selectedContract.isCancelled && !selectedContract.isExpired) || this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
      this.setperks();
      this.isPerksModuleEnabled = this.loggedInUserSettings.isFeatureEnabled(selectedContract.dealerId, PERKSGROUP);
    });

    this.breakpointObserver.observe([
      Breakpoints.XSmall
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

  setperks() {
    if (this.isPrimary) {
      this.perks = this.getSetting('Dashboard_Perks_Primary')?.split(';');
    } else {
      this.perks = this.getSetting('Dashboard_Perks_Secondary')?.split(';');
    }
    if (this.perks?.length === 1) {
      this.singlePerk = this.perks[0];
      this.singlePerkSvgIcon = this.getSetting(this.singlePerk + '_SvgIcon');
      this.singlePerkButtonOpenInNewWIndow = this.getSetting(this.singlePerk + '_Button_OpenInNewWindow').toLowerCase() === 'true';
      this.singlePerkButtonRoute = this.getSetting('URL_' + this.singlePerk);
      this.perkButtonAria = this.getLabel(this.singlePerk + '_Button');
      if (this.singlePerkButtonRoute === '{tutorial}') {
        this.isTutorial = true;
      }
      if (this.singlePerkButtonRoute.indexOf('{uri}') > -1) {
        this.singlePerkButtonRoute = this.singlePerkButtonRoute.replace('{uri}', encodeURIComponent(this.preInitSettingsService.getSiteSettings().hostName));
      }
    }
    this.setPartnerLabels();
    this.isPerkLoaded = true;
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name)?.Value
  }

  getLabel(name: string): string {
    return this.resourceService.getLabel(name);
  }

  // Check to see if any of the perks have a Partner label.
  // This is needed make the height of the Perks components align.
  setPartnerLabels() {
    this.perks.forEach(perk => {
      const partnerLabel = this.getLabel(perk + '_PartnerLabel');
      if (partnerLabel) {
        this.isPartnerLabelActive = true;
        return;
      }
    });
  }

  openTutorial(label: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.ariaLabel = label;
    dialogConfig.id = 'get-started-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      title: 'Account',
      content: '',
      buttonText: 'Next'
    };

    this.matDialog.open(GetStartedModalComponent, dialogConfig);
  }

}
